import { useEffect } from 'react';

const useCacheStatusPolling = ({ queryClient, realtimeEnabled, realtimeConnected }) => {
  useEffect(() => {
    if (realtimeEnabled && realtimeConnected) return undefined;
    const intervalId = setInterval(() => {
      queryClient.invalidateQueries({ queryKey: ['cacheStatus'] });
    }, 60 * 1000);
    return () => clearInterval(intervalId);
  }, [realtimeEnabled, realtimeConnected, queryClient]);
};

export default useCacheStatusPolling;
